var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"locale-changer"},[_c('div',{staticClass:"locale-changer"},_vm._l((_vm.langs),function(lang,i){return _c('div',{key:`Lang${i}`,staticClass:"locale",class:{ 'active' : _vm.$i18n.locale === lang },on:{"click":function($event){return _vm.changelocale(lang)}}},[_c('label',[_vm._v(_vm._s(lang))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }